import * as types from '../types';
import { IWorkOrdersApi } from '../contracts';
import { HttpApi } from './HttpApi';

export class WorkOrdersHttpApi extends HttpApi implements IWorkOrdersApi {
  async listWorkOrderCandidates(query: types.WorkOrderCandidateQuery = {}): Promise<types.WorkOrderCandidatePage> {
    const params: Record<string, string | number> = {};
    if (query.date) params.date = query.date;
    if (query.routeId) params.routeId = query.routeId;
    if (query.assignedTo) params.assignedTo = query.assignedTo;
    if (query.status) params.status = query.status;
    if (query.search?.trim()) params.search = query.search.trim();
    if (query.cursor) params.cursor = query.cursor;
    if (query.limit !== undefined) params.limit = query.limit;
    const response = await this.http.get<types.APIResponse<types.WorkOrderCandidatePage>>('/work-order-batches/candidates', { params });
    return response.data.data;
  }

  async resolveWorkOrderSelection(date: string, scope: 'DAY' | 'TECHNICIAN', assignedTo?: string): Promise<types.WorkOrderSelection> {
    const params: Record<string, string> = { date, scope };
    if (scope === 'TECHNICIAN' && assignedTo) params.assignedTo = assignedTo;
    const response = await this.http.get<types.APIResponse<types.WorkOrderSelection>>('/work-order-batches/candidates/selection', { params });
    return response.data.data;
  }

  async prepareWorkOrderBatch(data: types.PrepareWorkOrderBatchRequest): Promise<types.WorkOrderBatchSummary> {
    const response = await this.http.post<types.APIResponse<types.WorkOrderBatchSummary>>('/work-order-batches', data);
    return response.data.data;
  }

  async listWorkOrderBatches(query: types.WorkOrderBatchListQuery = {}): Promise<types.WorkOrderBatchList> {
    const params: Record<string, string | number> = {};
    if (query.date) params.date = query.date;
    if (query.status) params.status = query.status;
    if (query.search?.trim()) params.search = query.search.trim();
    if (query.page !== undefined) params.page = query.page;
    if (query.limit !== undefined) params.limit = query.limit;
    const response = await this.http.get<types.APIResponse<types.WorkOrderBatchList>>('/work-order-batches', { params });
    return response.data.data;
  }

  async getWorkOrderBatch(id: string): Promise<types.WorkOrderBatchDetail> {
    const response = await this.http.get<types.APIResponse<types.WorkOrderBatchDetail>>(`/work-order-batches/${encodeURIComponent(id)}`);
    return response.data.data;
  }

  async recordWorkOrderPrint(id: string, jobIds: string[]): Promise<types.RecordWorkOrderPrintResult> {
    const response = await this.http.post<types.APIResponse<types.RecordWorkOrderPrintResult>>(`/work-order-batches/${encodeURIComponent(id)}/print`, { jobIds });
    return response.data.data;
  }

  async confirmWorkOrderJobs(id: string, jobs: Array<{ id: string; printedVersion: string }>): Promise<types.ConfirmWorkOrderJobsResult> {
    const response = await this.http.post<types.APIResponse<types.ConfirmWorkOrderJobsResult>>(`/work-order-batches/${encodeURIComponent(id)}/confirm`, { jobs });
    return response.data.data;
  }
}
